import CreateShirtPage from './CreateShirtPage'
import connect from './connect'

export default connect(CreateShirtPage)
